import { Component, PropsWithChildren } from "react";
import { Stack } from "@altimateai/lego";

interface State {
  error: string | null;
}

class SidebarErrorBoundary extends Component<PropsWithChildren, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: unknown) {
    return { error: String(error instanceof Error ? error.message : error) };
  }

  render() {
    if (this.state.error) {
      return (
        <Stack direction="column" gap="md" className="al-p-4">
          <div className="al-text-sm al-font-medium">Something went wrong</div>
          <div className="al-text-xs al-text-muted-foreground">{this.state.error}</div>
        </Stack>
      );
    }
    return this.props.children;
  }
}

export default SidebarErrorBoundary;
